export default class Helpers {

    static getParamCount() {
        let query = window.location.search.substring(1);
        let params = query.split("&");

        return params.length
    }

    static getUrlParams(param) {
        let query = window.location.search.substring(1);
        let params = query.split("&");

        for (let i = 0; i < params.length; i++) {

            let pair = params[i].split("=");

            if (pair[0] === param) {
                return pair[1];
            }

        }

        return false;
    }

    static getUrlQueryString() {
        return window.location.search.substring(1);
    }

    static isInView(element, delay = 0) {
        if ($(element).length == 0) {
            return false;
        }
        let elementTop = $(element).offset().top + delay;
        let documentTop = $(window).scrollTop();
        let documentBottom = documentTop + $(window).outerHeight();

        return documentBottom > elementTop;
    }
}
